<div class="container" #leadsTable *appIsDesktop>
  @if (loadingTable) {
    <div class="loading">
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }
  <!-- desktop template -->
  @if (!loadingTable && !noResults) {
    <div id="leads-table-container" class="leads-table-container">
      <form #form="ngForm">
        <ds-table mat-table matSort (matSortChange)="sortData($event)" [dataSource]="leadsData" [displayedColumns]="displayedColumns">
          <ng-container matColumnDef="leadOwnerId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ appStrings.followUp_leads_leadOwner }} </th>
            <td mat-cell *matCellDef="let lead;let i = dataIndex" [id]="'leadOwner_'+i" >
              <ds-autocomplete [isDisabled]="lead.status === disabledStatus" (selectionChange)="onLeadOwnerSelect($event, i)" [options]="accountManagers" [control]="getLeadOwnerControl(i)"></ds-autocomplete>
            </td>
          </ng-container>
          <ng-container matColumnDef="companyInfo">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.followUp_leads_companyInfo }} </th>
            <td mat-cell class="break-word" *matCellDef="let lead;let i = dataIndex" [id]="'companyInfo_'+i">
              @if (lead.status !== disabledStatus) {
                <ds-link [linkRef]="getCompanyRedirect(lead.leadId)"> {{ lead.companyInfo }} </ds-link>
              } @else {
                {{ lead.companyInfo }}
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="contact">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.followUp_leads_contact }} </th>
            <td mat-cell *matCellDef="let lead;let i = dataIndex" [id]="'contact_'+i"> {{ lead.contact }} </td>
          </ng-container>
          <ng-container matColumnDef="source">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.followUp_leads_source }} </th>
            <td mat-cell *matCellDef="let lead;let i = dataIndex" [id]="'source_'+i"> {{ sources[lead.sourceTypeId] }} </td>
          </ng-container>
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ appStrings.followUp_leads_date }} </th>
            <td mat-cell *matCellDef="let lead;let i = dataIndex" [id]="'date_'+i"> {{ lead.date | date: dateFormat }} </td>
          </ng-container>
          <ng-container matColumnDef="lastUpdated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ appStrings.followUp_leads_lastUpdated }} </th>
            <td mat-cell *matCellDef="let lead;let i = dataIndex" [id]="'lastUpdated_'+i"> {{ lead.lastUpdated | dateAgo }} </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ appStrings.followUp_leads_status }} </th>
            <td mat-cell *matCellDef="let lead;let i = dataIndex" [id]="'status_'+i">
              <ds-select [isDisabled]="lead.status === disabledStatus" class="no-subscript" (selectionChange)="onStatusSelect($event, i)" [dropOptions]="statuses" [control]="getStatusControl(i)"></ds-select>
            </td>
          </ng-container>
          <ng-container matColumnDef="notes">
            <th mat-header-cell *matHeaderCellDef> {{ appStrings.label_notes }} </th>
            <td mat-cell *matCellDef="let lead;let i = dataIndex" [id]="'notes_'+i">
              @if (lead.displayNotesInput) {
                <ds-textfield (onBlur)="onNoteBlur(i)" class="no-subscript" [control]="getNotesControl(i)"></ds-textfield>
              }
              @if (!lead.displayNotesInput) {
                <div class="note-container">
                  <p class="note-display" [matTooltip]="getNoteTooltip(lead.noteText)"> {{ truncateNote(lead.noteText) }}</p>
                  <ds-button class="add-button" icon="add" size="medium" type="tertiary" variant="icon-only" iconStyle="material-icons" (onClick)="toggleInput(i)"></ds-button>
                </div>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef></th>
            <td class="edit-lead" mat-cell *matCellDef="let lead;let i = dataIndex" [id]="'edit_'+i">
              @if (lead.status !== disabledStatus) {
                <ds-button class="edit-lead-buton" size="medium" type="tertiary" variant="label-icon" icon="edit-outlined"
                  (onClick)="openEditLead(i)" iconStyle="material-icons-outlined" [label]="appStrings.button_edit">
                </ds-button>
              }
            </td>
          </ng-container>
        </ds-table>
      </form>
      @if (leadsTotal > 0) {
        <div class="pagination-container">
          <div class="page-count">
            <b>{{ pageOffset + 1 }} - {{ pageOffset + currentPageItemCount }}</b> {{appStrings.pagination_of}} <b>{{ leadsTotal }}</b>
          </div>
          <div class="pagination">
            <ds-pagination
              [totalPages]="totalPages"
              paginationDisplay="large"
              buttonTypes="nextPrevFirstLast"
              (pageChanged)="pageChanged($event)"
            ></ds-pagination>
          </div>
        </div>
      }
    </div>
  }
</div>

<!-- mobile template -->
<div class="container mobile" #leadsTable *appIsMobile>
  @if (loadingTable) {
    <div class="loading">
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }
  @if (!loadingTable && !noResults) {
    <div id="leads-table-container">
      <form #form="ngForm">
        @for (lead of leadsData; track lead; let i = $index) {
          <mat-expansion-panel class="mobile-card two-columns grey blue-border tall" [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title id="lead-card-header-container" class="card-header-container">
                <span class="card-header">
                  <span id="lead-card-title" class="title">
                    {{ lead.companyName }}
                  </span>
                  <span id="lead-card-subtitle" class="subtitle">
                    {{ lead.displayAddress }}
                  </span>
                </span>
                <span class="card-header-action">
                  @if (lead.status !== disabledStatus) {
                    <ds-button class="edit-lead-buton" size="medium" type="tertiary" variant="icon-only" icon="edit-outlined"
                      (onClick)="openEditLead(i)" iconStyle="material-icons-outlined" [id]="'edit_'+i">
                    </ds-button>
                  }
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ds-divider></ds-divider>
            <div class="content">
              <div class="row">
                <ds-autocomplete class="no-subscript input" [isDisabled]="lead.status === disabledStatus" (selectionChange)="onLeadOwnerSelect($event, i)"
                  [label]="appStrings.followUp_leads_leadOwner" label_orientation="horizontal-label" [options]="accountManagers" [control]="getLeadOwnerControl(i)">
                </ds-autocomplete>
              </div>
              <div class="row">
                <div class="column">
                  <typography [id]="'contact_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_leads_contact }} </typography>
                  <typography [id]="'contact_'+i" class="break-word" variant="body-2" weight="medium"> {{ lead.contact }} </typography>
                </div>
                <div class="column">
                  <typography [id]="'source_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_leads_source }} </typography>
                  <typography [id]="'source_'+i" variant="body-2" weight="medium"> {{ sources[lead.sourceTypeId] }} </typography>
                </div>
              </div>
              <div class="row">
                <div class="column">
                  <typography [id]="'date_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_leads_date }} </typography>
                  <typography [id]="'date_'+i" variant="body-2" weight="medium"> {{ lead.date | date: dateFormat }} </typography>
                </div>
                <div class="column">
                  <typography [id]="'lastUpdated_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.followUp_leads_lastUpdated }} </typography>
                  <typography [id]="'lastUpdated_'+i" variant="body-2" weight="medium"> {{ lead.lastUpdated | dateAgo }} </typography>
                </div>
              </div>
              <div class="row">
                <ds-select class="no-subscript input" [isDisabled]="lead.status === disabledStatus" (selectionChange)="onStatusSelect($event, i)" [dropOptions]="statuses"
                  [label]="appStrings.followUp_leads_status" label_orientation="vertical-label" [control]="getStatusControl(i)">
                </ds-select>
              </div>
              <div class="row">
                @if (lead.displayNotesInput) {
                  <ds-multiline class="input" [label]="appStrings.label_notes" label_orientation="vertical-label"
                    (onBlur)="onNoteBlur(i)" [control]="getNotesControl(i)" class="note-input">
                  </ds-multiline>
                }
                @if (!lead.displayNotesInput) {
                  <div class="note-container">
                    <typography [id]="'notes_label_'+i" variant="body-1" weight="medium"> {{ appStrings.label_notes }} </typography>
                    <div class="note">
                      <p class="note-display break-word"> {{ lead.noteText }}</p>
                      <ds-button class="add-button" icon="add" size="medium" type="tertiary" variant="icon-only"
                        iconStyle="material-icons" (onClick)="toggleInput(i)">
                      </ds-button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </mat-expansion-panel>
        }
      </form>
      @if (leadsTotal > 0) {
        <div class="pagination-container text-center">
          <div class="pagination">
            <ds-pagination
              [totalPages]="totalPages"
              buttonTypes="nextPrevFirstLast"
              (pageChanged)="pageChanged($event)"
              paginationDisplay="small"
            ></ds-pagination>
          </div>
        </div>
      }
    </div>
  }
</div>

@if (noResults) {
  <div id="noResults" class="no-results">
    <typography variant="mat-subtitle-1" weight="regular">
      {{ appStrings.leads_noResults }}
    </typography>
  </div>
}

@if (loading) {
  <div class="overlay full"  id="leads-table-loadingSpinner">
    <p class="text-center">{{ appStrings.pleaseWait }}</p>
    <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}

<ds-dialog
  [title]="appStrings.followUp_confirmation_changeLead_title"
  [description]="appStrings.followUp_confirmation_changeLead_content"
  [actionButtons]="leadOwnerConfirmationButtons"
  disableClose="true"
  [open]="leadOwnerConfirmationOpen$">
</ds-dialog>

<ds-dialog
  [title]="appStrings.followUp_confirmation_changeStatus_title"
  [description]="appStrings.followUp_confirmation_changeStatus_content"
  [actionButtons]="statusConfirmationButtons"
  disableClose="true"
  [open]="statusConfirmationOpen$">
</ds-dialog>